import React from 'react'

export default function HeroAsset (props) {
  return (
    <svg
      width="449"
      height="555"
      viewBox="0 0 449 555"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
      aria-hidden="true"
    >
      <rect
        x="102.008"
        y="170.955"
        width="63.4287"
        height="63.4287"
        stroke="#B0E4EB"
        strokeWidth="1.54704"
        strokeDasharray="10.83 10.83"
      />
      <g filter="url(#filter0_d_2231_47210)">
        <rect
          x="279.169"
          y="94.1074"
          width="157.831"
          height="125.893"
          fill="#393E42"
        />
      </g>
      <rect
        x="320.629"
        y="126.13"
        width="36.288"
        height="7.01841"
        fill="#C4C4C4"
      />
      <rect
        x="333.745"
        y="141.795"
        width="41.9717"
        height="7.01841"
        fill="#C4C4C4"
      />
      <rect
        x="333.745"
        y="155.146"
        width="30.6044"
        height="7.01841"
        fill="#C4C4C4"
      />
      <rect
        x="333.671"
        y="168.184"
        width="52.9162"
        height="6.99404"
        fill="#C4C4C4"
      />
      <rect
        x="333.671"
        y="181.216"
        width="42.1428"
        height="6.99404"
        fill="#C4C4C4"
      />
      <rect
        x="379.615"
        y="141.795"
        width="41.9717"
        height="7.01841"
        fill="#5CEBA0"
      />
      <rect
        x="368.284"
        y="155.146"
        width="30.6044"
        height="7.01841"
        fill="#C4C4C4"
      />
      <rect
        x="390.388"
        y="168.184"
        width="17.1106"
        height="6.99404"
        fill="#5CEBA0"
      />
      <path
        d="M309.114 149.546C307.269 149.546 305.877 149.092 304.94 148.183C304.003 147.303 303.535 145.996 303.535 144.264V135.447C303.535 134.226 303.322 133.317 302.896 132.721C302.498 132.125 301.859 131.77 300.979 131.656C300.638 131.6 300.468 131.415 300.468 131.103V127.397C300.468 127.056 300.638 126.872 300.979 126.843C301.859 126.73 302.498 126.375 302.896 125.778C303.322 125.182 303.535 124.287 303.535 123.095V114.448C303.535 112.716 304.003 111.41 304.94 110.529C305.877 109.649 307.269 109.209 309.114 109.209H312.991C313.133 109.209 313.246 109.266 313.331 109.379C313.445 109.465 313.502 109.578 313.502 109.72V113.852C313.502 113.994 313.445 114.122 313.331 114.235C313.246 114.32 313.133 114.363 312.991 114.363H311.841C311.159 114.363 310.605 114.604 310.179 115.087C309.753 115.57 309.54 116.223 309.54 117.046V123.904C309.54 125.296 309.342 126.417 308.944 127.269C308.547 128.093 307.922 128.703 307.07 129.101C306.9 129.186 306.9 129.271 307.07 129.356C307.922 129.782 308.547 130.421 308.944 131.273C309.342 132.125 309.54 133.246 309.54 134.638V141.666C309.54 142.518 309.753 143.171 310.179 143.625C310.605 144.108 311.159 144.349 311.841 144.349H312.991C313.133 144.349 313.246 144.392 313.331 144.477C313.445 144.591 313.502 144.719 313.502 144.861V149.035C313.502 149.177 313.445 149.29 313.331 149.376C313.246 149.489 313.133 149.546 312.991 149.546H309.114Z"
        fill="#61C9D7"
      />
      <path
        d="M74.6962 146.707C75.0867 147.098 75.7199 147.098 76.1104 146.707L82.4744 140.343C82.8649 139.953 82.8649 139.319 82.4744 138.929C82.0839 138.538 81.4507 138.538 81.0602 138.929L75.4033 144.586L69.7465 138.929C69.3559 138.538 68.7228 138.538 68.3323 138.929C67.9417 139.319 67.9417 139.953 68.3323 140.343L74.6962 146.707ZM74.4033 56L74.4033 146L76.4033 146L76.4033 56L74.4033 56ZM106.403 24C88.7302 24 74.4033 38.3269 74.4033 56L76.4033 56C76.4033 39.4315 89.8348 26 106.403 26L106.403 24Z"
        fill="#1D1F21"
      />
      <rect
        x="4.70703"
        width="145.994"
        height="95.9391"
        rx="6.15475"
        fill="white"
      />
      <rect
        x="77.915"
        y="13.8628"
        width="55.1388"
        height="68.6078"
        fill="#565E62"
      />
      <g clipPath="url(#clip0_2231_47210)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M116.623 43.2543C116.623 49.5182 111.498 54.6433 105.234 54.6433C98.9692 54.6433 93.8448 49.5182 93.8448 43.2543C93.8448 36.9904 98.9692 31.8652 105.234 31.8652C111.498 31.8652 116.623 36.9904 116.623 43.2543ZM82.4549 70.6718C82.4549 61.7295 97.688 57.1736 105.233 57.1736C112.778 57.1736 128.011 61.7295 128.011 70.6718V77.4208H82.4549V70.6718Z"
          fill="#FD7A7D"
        />
      </g>
      <rect
        x="21.9346"
        y="36.9282"
        width="46.2998"
        height="4.20907"
        fill="#B0E4EB"
      />
      <rect
        x="21.9346"
        y="44.5044"
        width="46.2998"
        height="4.20907"
        fill="#B0E4EB"
      />
      <rect
        x="21.9346"
        y="52.0806"
        width="46.2998"
        height="4.20907"
        fill="#B0E4EB"
      />
      <rect
        x="21.9346"
        y="59.6577"
        width="46.2998"
        height="4.20907"
        fill="#B0E4EB"
      />
      <rect
        x="21.9355"
        y="13.8628"
        width="8.41814"
        height="7.99723"
        fill="#05AAC0"
      />
      <rect
        x="33.2988"
        y="13.8628"
        width="34.9353"
        height="7.99723"
        fill="#61C9D7"
      />
      <rect
        x="21.9355"
        y="23.9639"
        width="46.2998"
        height="4.20907"
        fill="#61C9D7"
      />
      <rect
        x="21.9355"
        y="76.3188"
        width="25.2544"
        height="6.73451"
        fill="#61C9D7"
      />
      <rect
        x="49.7139"
        y="76.3188"
        width="18.5199"
        height="6.73451"
        fill="#61C9D7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M380.603 362.319C372.572 362.319 366.061 355.666 366.061 347.46C366.061 339.253 372.572 332.601 380.603 332.601C381.327 332.601 382.039 332.655 382.735 332.759C384.322 321.586 393.804 313 405.264 313C415.301 313 423.822 319.587 426.848 328.731C428.234 328.368 429.688 328.175 431.187 328.175C440.616 328.175 448.259 335.818 448.259 345.247C448.259 354.675 440.616 362.319 431.187 362.319C430.975 362.319 430.765 362.315 430.555 362.307V362.319H380.603V362.319Z"
        fill="white"
      />
      <path
        d="M408.111 341.293C407.721 340.902 407.088 340.902 406.697 341.293L400.333 347.657C399.943 348.047 399.943 348.681 400.333 349.071C400.724 349.462 401.357 349.462 401.747 349.071L407.404 343.414L413.061 349.071C413.452 349.462 414.085 349.462 414.475 349.071C414.866 348.681 414.866 348.047 414.475 347.657L408.111 341.293ZM330.233 462L364.578 462L364.578 460L330.233 460L330.233 462ZM408.404 418.174L408.404 342L406.404 342L406.404 418.174L408.404 418.174ZM364.578 462C388.783 462 408.404 442.378 408.404 418.174L406.404 418.174C406.404 441.274 387.678 460 364.578 460L364.578 462Z"
        fill="#1D1F21"
      />
      <g filter="url(#filter1_d_2231_47210)">
        <path
          d="M36.6455 160.309H279.404L339.613 220V526.003H36.6455V160.309Z"
          fill="white"
        />
      </g>
      <path d="M339.404 220L279.404 160V220H339.404Z" fill="#B0E4EB" />
      <rect
        x="77.4297"
        y="278.488"
        width="107.271"
        height="17.8785"
        fill="#D4D7D9"
      />
      <rect
        x="77.7012"
        y="303.48"
        width="69.185"
        height="18.2466"
        fill="#D4D7D9"
      />
      <rect
        x="153.729"
        y="303.48"
        width="71.4659"
        height="18.2466"
        fill="#D4D7D9"
      />
      <rect
        x="232.036"
        y="303.48"
        width="69.185"
        height="18.2466"
        fill="#D4D7D9"
      />
      <rect
        x="77.4297"
        y="424.495"
        width="223.482"
        height="17.8785"
        fill="#D4D7D9"
      />
      <rect
        x="77.4297"
        y="451.069"
        width="223.482"
        height="17.8785"
        fill="#D4D7D9"
      />
      <rect
        x="77.4297"
        y="451.069"
        width="223.482"
        height="17.8785"
        fill="#D4D7D9"
      />
      <rect
        x="77.7012"
        y="329.33"
        width="109.48"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="77.7012"
        y="355.179"
        width="109.48"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="193.263"
        y="329.33"
        width="107.959"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="193.641"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="204.505"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="215.366"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="231.661"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="242.525"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="258.816"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="269.68"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="280.543"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="291.408"
        y="355.179"
        width="9.50505"
        height="17.4863"
        fill="#D4D7D9"
      />
      <rect
        x="193.639"
        y="278.488"
        width="107.271"
        height="17.8785"
        fill="#D4D7D9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.9414 406.617H207.051V412.576H75.9414V406.617Z"
        fill="#E9EBEC"
      />
      <rect
        x="75.9414"
        y="393.207"
        width="224.972"
        height="5.95952"
        fill="#E9EBEC"
      />
      <rect
        x="134.043"
        y="215.913"
        width="108.761"
        height="5.95952"
        fill="#D4D7D9"
      />
      <rect
        x="75.9414"
        y="381.29"
        width="224.972"
        height="5.95952"
        fill="#E9EBEC"
      />
      <rect
        x="148.944"
        y="203.994"
        width="78.9636"
        height="5.95952"
        fill="#D4D7D9"
      />
      <rect
        x="76.71"
        y="246.485"
        width="223.425"
        height="17.8214"
        fill="#5CEBA0"
        stroke="#1D1F21"
        strokeWidth="1.54704"
      />
      <rect
        x="76.71"
        y="277.772"
        width="107.214"
        height="18.4205"
        fill="#5CEBA0"
        stroke="#1D1F21"
        strokeWidth="1.54704"
      />
      <path
        d="M77.9567 223.014C77.8647 223.014 77.7819 222.987 77.7083 222.931C77.653 222.858 77.6254 222.775 77.6254 222.683V204.021C77.6254 203.929 77.653 203.855 77.7083 203.8C77.7819 203.726 77.8647 203.689 77.9567 203.689H81.1867C81.2787 203.689 81.3524 203.726 81.4076 203.8C81.4812 203.855 81.518 203.929 81.518 204.021V222.683C81.518 222.775 81.4812 222.858 81.4076 222.931C81.3524 222.987 81.2787 223.014 81.1867 223.014H77.9567ZM84.3255 216.527C84.2335 216.527 84.1507 216.499 84.077 216.444C84.0218 216.37 83.9942 216.287 83.9942 216.195V213.517C83.9942 213.425 84.0218 213.352 84.077 213.297C84.1507 213.223 84.2335 213.186 84.3255 213.186H93.353C93.445 213.186 93.5186 213.223 93.5738 213.297C93.6474 213.352 93.6843 213.425 93.6843 213.517V216.195C93.6843 216.287 93.6474 216.37 93.5738 216.444C93.5186 216.499 93.445 216.527 93.353 216.527H84.3255ZM107.493 207.195C107.806 207.95 107.962 208.852 107.962 209.901V218.211C107.962 219.204 107.704 220.088 107.189 220.861C106.674 221.615 105.947 222.204 105.008 222.628C104.069 223.033 102.993 223.235 101.778 223.235C100.582 223.235 99.5235 223.033 98.6032 222.628C97.683 222.204 96.9652 221.625 96.4499 220.888C95.9346 220.134 95.6769 219.269 95.6769 218.293V217.52C95.6769 217.428 95.7045 217.355 95.7597 217.3C95.8334 217.226 95.9162 217.189 96.0082 217.189H99.2382C99.3302 217.189 99.4038 217.226 99.4591 217.3C99.5327 217.355 99.5695 217.428 99.5695 217.52V217.769C99.5695 218.376 99.7719 218.882 100.177 219.287C100.6 219.692 101.134 219.895 101.778 219.895C102.459 219.895 103.011 219.692 103.434 219.287C103.858 218.864 104.069 218.33 104.069 217.686V215.119C104.069 215.063 104.051 215.027 104.014 215.008C103.977 214.99 103.941 214.999 103.904 215.036C103.149 215.68 102.155 216.002 100.922 216.002C99.818 216.002 98.8241 215.754 97.9407 215.257C97.0757 214.741 96.3947 214.005 95.8978 213.048C95.4377 212.183 95.2076 211.125 95.2076 209.873C95.2076 208.787 95.3916 207.83 95.7597 207.002C96.2198 205.916 96.956 205.06 97.9683 204.435C98.9989 203.809 100.204 203.496 101.585 203.496C102.984 203.496 104.198 203.827 105.229 204.49C106.278 205.134 107.033 206.036 107.493 207.195ZM101.585 212.744C102.542 212.744 103.232 212.367 103.655 211.612C103.931 211.134 104.069 210.517 104.069 209.763C104.069 209.155 103.95 208.594 103.711 208.079C103.306 207.269 102.606 206.864 101.612 206.864C100.655 206.864 99.956 207.269 99.5143 208.079C99.2382 208.594 99.1002 209.174 99.1002 209.818C99.1002 210.517 99.2566 211.125 99.5695 211.64C100.03 212.376 100.701 212.744 101.585 212.744Z"
        fill="#565E62"
      />
      <rect
        x="70.0859"
        y="240.268"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="301.239"
        y="240.268"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="301.239"
        y="264.983"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="70.0859"
        y="264.983"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="70.0859"
        y="272.251"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="183.481"
        y="272.251"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="183.481"
        y="295.512"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <rect
        x="70.0859"
        y="295.512"
        width="5.81523"
        height="5.81523"
        fill="#1D1F21"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1528 496.449C56.2275 496.054 72.377 479.987 72.3769 460.225C72.3769 440.463 56.2275 424.396 36.1528 424.001L36.1528 496.449Z"
        fill="#FCE969"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.2242 424C16.1495 424.395 1.43913e-06 440.462 3.1668e-06 460.224C4.89447e-06 479.986 16.1495 496.053 36.2242 496.448L36.2242 424Z"
        fill="#D3B200"
      />
      <circle
        cx="23.1849"
        cy="23.1849"
        r="23.1849"
        transform="matrix(-1 0 0 1 59.4082 436.861)"
        fill="#1D1F21"
      />
      <g clipPath="url(#clip1_2231_47210)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.502 462.889C37.1291 463.568 37.9573 463.95 38.7736 463.95L38.7973 463.929C38.9037 463.929 39.0102 463.919 39.1166 463.908L39.1167 463.908C40.258 463.762 40.9408 462.978 41.4471 462.397L41.4712 462.369C41.5052 462.33 41.543 462.286 41.5827 462.24C41.777 462.013 42.0156 461.734 42.0746 461.69C42.0773 461.693 42.0812 461.696 42.0864 461.7C42.1039 461.713 42.1354 461.737 42.181 461.786C42.2994 461.924 42.4058 462.062 42.5005 462.21C42.5112 462.225 42.5219 462.24 42.5328 462.256C42.7141 462.51 42.9201 462.799 43.2104 463.07C44.216 463.982 45.5648 464.11 46.7361 463.399C47.3395 463.027 47.8719 462.497 48.4043 461.712L46.3811 460.608C46.038 461.117 45.7068 461.457 45.3992 461.648C45.1862 461.786 45.1152 461.796 44.8904 461.595C44.7952 461.509 44.7062 461.384 44.6098 461.248C44.5744 461.199 44.538 461.147 44.5 461.096C44.3462 460.873 44.1805 460.661 44.0031 460.459C43.5535 459.961 42.9974 459.664 42.3822 459.611C40.9624 459.494 40.1342 460.449 39.59 461.086C39.3415 461.383 38.9866 461.796 38.7855 461.818C38.7381 461.818 38.5488 461.754 38.3477 461.531C37.8745 461.011 37.4485 460.353 37.0344 459.696C36.8451 459.398 36.5257 459.207 36.1471 459.165C35.7685 459.123 35.4017 459.25 35.1414 459.494C34.3369 460.268 33.3786 461.043 32.4912 460.937C32.1836 460.895 31.8523 460.799 31.5211 460.64C31.5506 460.603 31.5832 460.566 31.6157 460.528C31.6482 460.491 31.6808 460.454 31.7104 460.417C33.0236 458.815 33.7099 456.884 33.627 454.984C33.5206 452.448 31.8997 450.75 29.5807 450.75C27.9244 450.75 26.6702 451.44 26.055 452.703C24.8246 455.186 26.3745 459.165 27.9244 460.725C27.1317 461.192 26.268 461.563 25.4043 461.903L26.339 463.844C27.4984 463.388 28.6697 462.879 29.7345 462.168C30.5391 462.667 31.3436 462.953 32.1718 463.049C33.6152 463.218 34.8338 462.592 35.7212 461.924C35.9578 462.253 36.2181 462.582 36.502 462.889ZM28.2201 453.562C28.3858 453.223 28.6816 452.873 29.5807 452.873V452.862C31.0951 452.862 31.2489 454.687 31.2608 455.059C31.3199 456.48 30.7994 457.934 29.8055 459.154L29.699 459.282C28.6106 458.199 27.4629 455.09 28.2201 453.562ZM48.4043 466.15H25.4043V468.35H48.4043V466.15Z"
          fill="#FCE969"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_2231_47210"
          x="273.598"
          y="90.0219"
          width="168.973"
          height="137.035"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.48564" />
          <feGaussianBlur stdDeviation="2.78558" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2231_47210"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2231_47210"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2231_47210"
          x="14.388"
          y="143.986"
          width="347.483"
          height="410.209"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5.93534" />
          <feGaussianBlur stdDeviation="11.1288" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2231_47210"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2231_47210"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_2231_47210">
          <rect
            width="45.8839"
            height="45.8839"
            fill="white"
            transform="translate(82.293 31.7012)"
          />
        </clipPath>
        <clipPath id="clip1_2231_47210">
          <rect
            width="23"
            height="22"
            fill="white"
            transform="translate(25.4043 448)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
